import { TOTAL_IMAGES } from '../constants';

// Function to get the shortest path between two images (considering circular nature)
export const getShortestPath = (from, to) => {
  const directPath = [];
  const wrapPath = [];

  // Direct path
  if (from <= to) {
    for (let i = from; i <= to; i++) {
      directPath.push(i);
    }
  } else {
    for (let i = from; i >= to; i--) {
      directPath.push(i);
    }
  }

  // Wrap around path
  if (from <= to) {
    // Go backwards: from -> 0 -> 59 -> ... -> to
    for (let i = from; i >= 0; i--) {
      wrapPath.push(i);
    }
    for (let i = TOTAL_IMAGES - 1; i >= to; i--) {
      wrapPath.push(i);
    }
  } else {
    // Go forwards: from -> 59 -> 0 -> ... -> to
    for (let i = from; i < TOTAL_IMAGES; i++) {
      wrapPath.push(i);
    }
    for (let i = 0; i <= to; i++) {
      wrapPath.push(i);
    }
  }

  // Return the shorter path
  return directPath.length <= wrapPath.length ? directPath : wrapPath;
};
